import type { BookedFlightItinerary } from "@b2bportal/air-booking-api";
import {
  ScheduleChangeDisplayMode,
  type ScheduleChangeDiffModel,
} from "@b2bportal/core-types";
import { getSliceDepartureDate } from "@b2bportal/core-utilities";
import {
  FlightItinerarySliceDetails,
  FlightScheduleChangeForm,
  useFlightScheduleChangeDetails,
  type IFlightScheduleChangeModalData,
} from "@tenant/flights";

export interface IFlightScheduleChangeDetailsProps {
  classNames?: Partial<{
    contentBody: string;
    contentHeader: string;
    contentSubtitle: string;
    contentTitle: string;
    originalSlice: string;
    originalSliceTitle: string;
    root: string;
    sliceComparator: string;
    updatedSlice: string;
    updatedSliceTitle: string;
  }>;
  hoursToDeparture?: number;
  itinerary: BookedFlightItinerary;
  scheduleChangeDataModel: IFlightScheduleChangeModalData;
  scheduleChangeDiffs: ScheduleChangeDiffModel;
}

export const FlightScheduleChangeDetails = (
  props: IFlightScheduleChangeDetailsProps
) => {
  const {
    classNames,
    scheduleChangeDataModel: { context, handlers, text },
  } = props;
  const {
    context: { sliceComparatorList },
  } = useFlightScheduleChangeDetails(props);

  return (
    <div className={classNames?.root}>
      <div className={classNames?.contentHeader}>
        <span className={classNames?.contentTitle}>{text.details.title}</span>
        <span
          className={classNames?.contentSubtitle}
          dangerouslySetInnerHTML={{ __html: text.details.body }}
        />
      </div>
      <div className={classNames?.contentBody}>
        {sliceComparatorList.map((sliceComparatorListItem) => {
          const { destinationCity, originalSlice, sliceChange, sliceKey } =
            sliceComparatorListItem;

          return (
            <div className={classNames?.sliceComparator} key={sliceKey}>
              <div className={classNames?.updatedSlice}>
                <span className={classNames?.updatedSliceTitle}>
                  {text.details.updatedSliceTitle(sliceChange.direction)}
                </span>
                <FlightItinerarySliceDetails
                  destination={destinationCity}
                  direction={sliceChange.direction}
                  formattedDepartureDate={handlers.dateFormatter(
                    getSliceDepartureDate(sliceChange.updatedSlice)
                  )}
                  itinerary={props.itinerary}
                  scheduleChangeDisplayMode={ScheduleChangeDisplayMode.updated}
                  slice={sliceChange.updatedSlice}
                  sliceChangeContext={sliceChange}
                />
              </div>
              <div className={classNames?.originalSlice}>
                <span className={classNames?.originalSliceTitle}>
                  {text.details.originalSliceTitle(sliceChange.direction)}
                </span>
                <FlightItinerarySliceDetails
                  destination={destinationCity}
                  direction={sliceChange.direction}
                  formattedDepartureDate={handlers.dateFormatter(
                    getSliceDepartureDate(originalSlice)
                  )}
                  itinerary={props.itinerary}
                  scheduleChangeDisplayMode={ScheduleChangeDisplayMode.original}
                  slice={originalSlice}
                  sliceChangeContext={sliceChange}
                />
              </div>
            </div>
          );
        })}
        <FlightScheduleChangeForm
          hoursToDeparture={props.hoursToDeparture}
          onSubmit={handlers.onFormSubmit}
          outboundChanged={context.outboundChanged}
          returnChanged={context.returnChanged}
        />
      </div>
    </div>
  );
};
